import React, { useEffect, useState } from "react";
import { PaginationInfo } from "../../models/security.model";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import {
  GetInProcessLoansFilter,
  GetInProcessLoansResponse,
} from "../../models/loan.model";
import { useMutation } from "react-query";
import {
  GetInProcessLoans,
  GetInProcessLoansReportExcel,
  GetLoanRequestStatuses,
} from "../../services/loan.service";
import { Box, Grid, Tooltip } from "@mui/material";
import TableRowSkeleton from "../../components/skeletons/TableRowSkeleton";
import InProcessLoansTable from "./components/InProcessLoansTable";
import InProcessLoansListFilters from "./components/InProcessLoansListFilters";
import {
  GetLoanTemplates,
  GetOrganizations,
} from "../../services/cartable.service";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { useHistory } from "react-router-dom";

const CancleLoanList = () => {
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [showFilter, setShowFilter] = useState(true);
  const [inProcessLoansList, setInProcessLoansList] = useState<
    GetInProcessLoansResponse[]
  >([]);
  const [filterObject, setFilterObject] = useState<GetInProcessLoansFilter>();
  const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [organizationOptions, setOrganizationOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [loanRequestStatus, setLoanRequestStatus] = React.useState<
    GetStatusResponse[]
  >([]);
  const history = useHistory();

  // service calls
  const { mutate: GetInProcessLoansMutate, isLoading } = useMutation(
    GetInProcessLoans,
    {
      onSuccess: (data: ApiResultModel<GetInProcessLoansResponse[]>) => {
        if (data) {
          setInProcessLoansList(data.data);
          setPageInfo(data.pageInfo);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetInProcessLoansReportExcelMutate } = useMutation(
    GetInProcessLoansReportExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetLoanTemplatesMutate } = useMutation(GetLoanTemplates, {
    onSuccess: (data: GetStatusResponse[]) => {
      if (data) {
        setLoanTemplateOptions(data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetOrganizationsMutate } = useMutation(GetOrganizations, {
    onSuccess: (data: GetStatusResponse[]) => {
      if (data) {
        setOrganizationOptions(data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetLoanRequestStatusesMutate } = useMutation(
    GetLoanRequestStatuses,
    {
      onSuccess: (data: GetStatusResponse[]) => {
        if (data) {
          setLoanRequestStatus(data);
        }
      },
      onError: () => {},
    }
  );

  //handlers
  const handleClick = (referenceKey: string) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    history.push({
      pathname: "/Search/SupplierSearch1/request-find-detail",
      state: { id: referenceKey, activeCancleButton: true },
    });
    localStorage.setItem(
      "activeCancleButton",
      JSON.stringify({ activeCancleButton: true })
    );
  };
  const handleExportExcel = () => {
    GetInProcessLoansReportExcelMutate({
      ...filterObject!,
    });
  };
  useEffect(() => {
    GetInProcessLoansMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  }, [filterObject, currentPaginationInfo]);

  useEffect(() => {
    GetLoanTemplatesMutate();
    GetOrganizationsMutate();
    GetLoanRequestStatusesMutate();
  }, []);

  return (
    <div>
      <Grid container>
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="فیلتر" arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/filter.png"
                alt=""
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={handleExportExcel}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box>
        </Grid>
        {showFilter && (
          <Grid item xs={12} sx={{ marginBottom: "20px" }}>
            <InProcessLoansListFilters
              filterObject={filterObject!}
              setFilterObject={setFilterObject}
              setCurrentPaginationInfo={setCurrentPaginationInfo}
              loanTemplateOptions={loanTemplateOptions}
              organizationOptions={organizationOptions}
              loanRequestStatus={loanRequestStatus}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          {!isLoading ? (
            <Grid item xs={12} sx={{ marginBottom: "20px" }}>
              <InProcessLoansTable
                inProcessLoansList={inProcessLoansList}
                pageInfo={pageInfo}
                currentPaginationInfo={currentPaginationInfo}
                setCurrentPaginationInfo={setCurrentPaginationInfo}
                handleClick={handleClick}
              />
            </Grid>
          ) : (
            <span style={{ marginBottom: "10px", width: "100%" }}>
              <TableRowSkeleton rowsNum={10} columnsNum={12} />
            </span>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default CancleLoanList;
